module.exports = __webpack_public_path__ + "img/sidebar_banner.adc8fc1c.jpg";